var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.817 11.997 8.592-8.572A2.006 2.006 0 0 0 20.572.588L12 9.179 3.428.588A2.006 2.006 0 1 0 .591 3.425l8.592 8.572L.59 20.568a2 2 0 0 0 0 2.838 2 2 0 0 0 2.837 0L12 14.814l8.572 8.592a2 2 0 0 0 2.837 0 2 2 0 0 0 0-2.838z"
  })));
};
export default SvgCross;